// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { DeferredPromptProvider } from "./contexts/DeferredPromptContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <DeferredPromptProvider> {/* Proveedor del contexto */}
      <Router>
        <App />
      </Router>
    </DeferredPromptProvider>
  </React.StrictMode>
);
